import { maskInput, maskPhoneInput } from "./components/maskInputs";
import EventBus from "./events/EventBus";
function maskInputs() {
    for (const phoneInput of Array.from(document.querySelectorAll('.input-phone'))) {
        maskPhoneInput(phoneInput);
    }
    for (const inputPostcode of Array.from(document.querySelectorAll('.input-postcode'))) {
        maskInput(inputPostcode, {
            mask: /^[1-6]\d{0,5}$/
        });
    }
}
window.maskInputs = maskInputs;
EventBus.on('modal:open', maskInputs);
maskInputs();
